import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as PodcastActions from '../../actions';
import * as D from '../../deps';
import BackstagePodcastSidebarButtons from '../common/BackstagePodcastSidebarButtons';

export class BackstagePodcastPageBase extends React.Component {
  static propTypes = {
    heroImageUrl: PropTypes.string,
    isMobileDevice: PropTypes.bool,
    mainContent: PropTypes.node.isRequired,
    pandoraId: PropTypes.string.isRequired,
    playResumeSource: PropTypes.func.isRequired,
    requestGetDetails: PropTypes.func.isRequired,
    subheaderLarge: PropTypes.node,
    subheaderSmall: PropTypes.node,
    title: PropTypes.string,
    titleUrl: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.pandoraId) {
      this.props.requestGetDetails({ pandoraId: this.props.pandoraId });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pandoraId !== this.props.pandoraId) {
      this.props.requestGetDetails({ pandoraId: this.props.pandoraId });
    }
  }

  static contextType = D.Utils.Context.AppContext;

  // This method is only used for showing the dialog modal/redirect with branch.io on mobile web.
  // Ideally we'd want to abstract this out possibly into BackstagePodcastSidebarButtons
  artworkPlayOnClick = () => {
    const { playResumeSource, pandoraId } = this.props;
    playResumeSource({
      id: pandoraId,
      context: D.Constants.Ads.Rewards.ContextTypes.BACKSTAGE,
      pageUrl: this.props.titleUrl,
    });
    this.context.integration.action.clicked({
      pandoraId,
      contentSection: D.Constants.ContentSections.BackstageContentSections.CONTROL_BAR,
      componentEventType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
    });
  };

  render() {
    const sidebarButtons = !this.props.isMobileDevice ? (
      <BackstagePodcastSidebarButtons
        pandoraId={this.props.pandoraId}
        podcastTitle={this.props.title}
      />
    ) : null;
    const artworkPlayOnClick = !sidebarButtons ? this.artworkPlayOnClick : null;

    const headerProps = {
      title: this.props.title,
      titleUrl: this.props.titleUrl,
      subTitleLrg: this.props.subheaderLarge,
      subTitleSm: this.props.subheaderSmall,
    };

    return (
      <D.BackstageLayout2
        entityIdentifier={this.props.pandoraId}
        headerProps={headerProps}
        heroImageUrl={this.props.heroImageUrl}
        sidebarButtons={sidebarButtons}
        renderArtworkPlayButton={this.props.isMobileDevice}
        playOnClick={artworkPlayOnClick}
        mainContent={this.props.mainContent}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const { pandoraId } = ownProps;
  const catalogDetails = D.getDetails(state, pandoraId);
  const annotation = D.getAnnotationsById(state, pandoraId);

  const title = D.Utils.Core.getFromMap(annotation, 'name');
  const titleUrl = D.Utils.Core.getFromMap(annotation, 'shareableUrlPath');
  const heroImageUrl = D.getHero(
    state,
    catalogDetails,
    300,
    D.Constants.SourceTypes.PandoraTypes.PODCAST,
  );
  const isMobileDevice = D.isMobileDevice(state);

  return {
    heroImageUrl,
    isMobileDevice,
    pandoraId,
    title,
    titleUrl,
  };
}

const mapDispatchToProps = {
  requestGetDetails: PodcastActions.requestGetDetails,
  playResumeSource: D.Actions.UseCases.playResumeSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackstagePodcastPageBase);
